import { FC } from 'react';
import { Tabs } from 'components';
import { INVOICE_TAB_STATUS, INVOICE_TAB_TITLE, TAB_HEADS } from '../constants';

interface InvoiceTabsProps {
  selectedTab: string;
  onTabSelect: (tab: { title: INVOICE_TAB_TITLE; value: INVOICE_TAB_STATUS; id: number }) => void;
  counts?: Record<string, number>;
}

const InvoiceTabs: FC<InvoiceTabsProps> = ({ selectedTab, onTabSelect, counts }) => {
  const handleTabClick = (tabTitle: INVOICE_TAB_TITLE) => {
    const tab = TAB_HEADS.find(t => t.title === tabTitle);
    if (tab) {
      onTabSelect(tab);
    }
  };

  return (
    <div className="border-b px-6">
      <Tabs
        tabs={TAB_HEADS}
        selectedTab={selectedTab}
        onTabSelect={handleTabClick}
        tabStyle="px-4"
        className="gap-4"
        hasCount={true}
        countMap={counts}
      />
    </div>
  );
};

export default InvoiceTabs;
